// extracted by mini-css-extract-plugin
module.exports = {"password":"styles_password__3sSif","subtitle":"styles_subtitle__2xUcv"};